import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./Testemonial.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import { PortableText } from "@portabletext/react";
export interface Testimony {
  quotee: string;
  quotee_background: any;
  quote: string;
  image: SanityImageObject;
}
export const Testimonial: React.FC<{
  testimonies: Testimony[];
}> = t0 => {
  const $ = _c(31);
  const {
    testimonies
  } = t0;
  const [currentTestimony, setCurrentTestimony] = React.useState(0);
  const [touchStart, setTouchStart] = React.useState(0);
  const [touchEnd, setTouchEnd] = React.useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      setTouchStart(e.targetTouches[0].clientX);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleTouchStart = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_0 => {
      setTouchEnd(e_0.targetTouches[0].clientX);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleTouchMove = t2;
  let t3;
  if ($[2] !== currentTestimony || $[3] !== testimonies.length || $[4] !== touchEnd || $[5] !== touchStart) {
    t3 = () => {
      if (touchStart - touchEnd > 100) {
        setCurrentTestimony(Math.min(testimonies.length - 1, currentTestimony + 1));
      }
      if (touchStart - touchEnd < -100) {
        setCurrentTestimony(Math.max(0, currentTestimony - 1));
      }
    };
    $[2] = currentTestimony;
    $[3] = testimonies.length;
    $[4] = touchEnd;
    $[5] = touchStart;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleTouchEnd = t3;
  let t4;
  if ($[7] !== currentTestimony || $[8] !== testimonies.length) {
    t4 = testimonies.length > 1 && <button className={`${styles.testimonial__arrow} ${styles.testimonial__arrow__backward} ${currentTestimony === 0 ? styles.testimonial__arrow__hidden : ""}`} onClick={e_1 => {
      e_1.currentTarget.blur();
      setCurrentTestimony(Math.max(0, currentTestimony - 1));
    }} aria-label="Previous testimonial"><div>←</div></button>;
    $[7] = currentTestimony;
    $[8] = testimonies.length;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = `translateX(${currentTestimony * -100}%)`;
  let t6;
  if ($[10] !== t5) {
    t6 = {
      transform: t5
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== testimonies) {
    t7 = testimonies.map(_temp);
    $[12] = testimonies;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className={styles.testimonialtrackinner} style={t6}>{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== handleTouchEnd || $[18] !== t8) {
    t9 = <div className={styles.testimonialtrack} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>{t8}</div>;
    $[17] = handleTouchEnd;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== currentTestimony || $[21] !== testimonies.length) {
    t10 = testimonies.length > 1 && <button className={`${styles.testimonial__arrow} ${styles.testimonial__arrow__forward} ${currentTestimony === testimonies.length - 1 ? styles.testimonial__arrow__hidden : ""}`} onClick={e_2 => {
      e_2.currentTarget.blur();
      setCurrentTestimony(Math.min(testimonies.length - 1, currentTestimony + 1));
    }} aria-label="Next testimonial"><div>→</div></button>;
    $[20] = currentTestimony;
    $[21] = testimonies.length;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== currentTestimony || $[24] !== testimonies) {
    t11 = testimonies.length > 1 && <div className={styles.testimonial__dots}>{testimonies.map((_, i) => <button key={i} className={`${styles.testimonial__dot} ${currentTestimony === i ? styles.testimonial__dot__active : ""}`} onClick={e_3 => {
        e_3.currentTarget.blur();
        setCurrentTestimony(i);
      }} aria-label="Go to testimonial" />)}</div>;
    $[23] = currentTestimony;
    $[24] = testimonies;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t4 || $[29] !== t9) {
    t12 = <section className={styles.wrapper}>{t4}{t9}{t10}{t11}</section>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t4;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
function _temp(t0) {
  const {
    quotee,
    quotee_background,
    quote,
    image
  } = t0;
  return <div className={styles.testimonial} key={quotee}>{quote && <h4 className={styles.testemonial__quote}>“{quote}”</h4>}<div className={styles.testemonial__image}>{image && <ResponsiveImage image={image} sizes="(min-width: 1181px) 170px, 120px" />}</div><div className={styles.testimonial__bio}><p>{quotee}</p><div className={styles.tesimonial__background}>{" "}↳  <PortableText value={quotee_background} /></div></div></div>;
}